/*
 * UNIK footer (F5-09): menu groups fold on mobile (below 990 px) with aria-expanded, are
 * always open on desktop; the newsletter result is focused after posting back.
 */
(() => {
  if (customElements.get('unik-footer')) return;

  class UnikFooter extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.mobile = window.matchMedia('(max-width: 989px)');
      this.buttons = Array.from(this.querySelectorAll('[data-unik-footer-toggle]'));
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!this.mobile.matches) return;
          const open = button.getAttribute('aria-expanded') !== 'true';
          button.dataset.mobileOpen = String(open);
          this.setState(button, open);
        });
      });
      this.onBreakpoint = () =>
        this.buttons.forEach((button) => {
          button.tabIndex = this.mobile.matches ? 0 : -1;
          this.setState(button, !this.mobile.matches || button.dataset.mobileOpen === 'true');
        });
      this.mobile.addEventListener?.('change', this.onBreakpoint);
      this.onBreakpoint();

      const result = this.querySelector('[data-unik-footer-result]');
      if (result && window.location.hash === `#${result.closest('form')?.id}`) result.focus();
    }

    disconnectedCallback() {
      this.mobile?.removeEventListener?.('change', this.onBreakpoint);
      this.ready = false;
    }

    setState(button, open) {
      const content = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
      if (!content) return;
      // Do not leave focus in a group that is being hidden.
      if (!open && content.contains(document.activeElement)) button.focus();
      button.setAttribute('aria-expanded', String(open));
      content.hidden = !open;
    }
  }

  customElements.define('unik-footer', UnikFooter);
})();
